(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cc-complementary-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cc-complementary-products')) {
    customElements.define('cc-complementary-products', class extends HTMLElement {
      connectedCallback() {
        if (this.initialised) return;
        this.initialised = true;
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-cc-add]');
          if (!button || !this.contains(button)) return;
          event.preventDefault();
          this.addAccessory(button);
        });
        this.loadRecommendations();
      }

      async loadRecommendations() {
        try {
          const response = await fetch(this.dataset.url, { credentials: 'same-origin' });
          if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const content = html.querySelector('cc-complementary-products');
          if (!content || !content.querySelector('.cc-complements__item') || !this.isConnected) return;
          this.innerHTML = content.innerHTML;
          this.hidden = false;
        } catch (_) {
          this.hidden = true;
        }
      }

      async updateCartCount() {
        try {
          const response = await fetch(this.dataset.cartUrl, { credentials: 'same-origin', cache: 'no-store' });
          if (!response.ok) return;
          const cart = await response.json();
          if (!Number.isInteger(cart.item_count)) return;
          document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count || ''; });
          document.querySelectorAll('[data-cart-count-bubble]').forEach(el => { el.classList.toggle('hide', cart.item_count === 0); });
        } catch (_) {}
      }

      async addAccessory(button) {
        if (this.busy || button.disabled) return;
        this.busy = true;
        const buttons = Array.from(this.querySelectorAll('[data-cc-add]'));
        const previousStates = buttons.map(el => el.disabled);
        buttons.forEach(el => { el.disabled = true; });
        const label = button.textContent;
        const status = this.querySelector('.cc-complements__status');
        const cartLink = this.querySelector('.cc-complements__cart');
        let added = false;
        button.textContent = this.dataset.adding;
        button.setAttribute('aria-busy', 'true');
        status.textContent = '';
        try {
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: button.dataset.ccAdd, quantity: 1 }] })
          });
          const result = await response.json();
          if (!response.ok || result.status >= 400) {
            throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
          }
          if (!Array.isArray(result.items) || !result.items.some(item => String(item.variant_id || item.id) === button.dataset.ccAdd)) {
            throw new Error(this.dataset.error);
          }
          added = true;
          status.textContent = this.dataset.added;
          cartLink.hidden = false;
        } catch (error) {
          status.textContent = error.message && !(error instanceof TypeError) ? error.message : this.dataset.error;
          cartLink.hidden = false;
        } finally {
          buttons.forEach((el, index) => { el.disabled = previousStates[index]; });
          button.disabled = added;
          button.textContent = added ? this.dataset.added : label;
          if (added) button.removeAttribute('aria-label');
          button.removeAttribute('aria-busy');
          this.busy = false;
          this.updateCartCount();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
